export const TOKEN_EXPIRED = 'token_expired';
export const OPEN_FAVORITE_CLAIM = 'open_favorite_claim';
export const OPEN_MENU = 'open_menu';

export default {
  TOKEN_EXPIRED,
  OPEN_FAVORITE_CLAIM,
  OPEN_MENU
};
